import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ba-product-data-margin ba-column-title ba-text ba-text-right"
};
const _hoisted_2 = {
  class: "ba-double-content"
};
const _hoisted_3 = {
  class: "ba-double-content-inner"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_currency_value = _resolveComponent("currency-value");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_percentage_value, {
    value: $props.percentage_value,
    type: "ba_table"
  }, null, 8, ["value"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_currency_value, {
    value: $props.value,
    precision: 1,
    currency: $props.currency
  }, null, 8, ["value", "currency"])])])]);
}